import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Layout, Input, Button, Form, Card, Divider, List } from "antd";
import {} from "./HomePageService";
import Loader from "../../components/Loader/Loader";
import "./HomePage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";

const { Content } = Layout;

export interface HomePageInterface {}

const HomePage = (props: HomePageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const userRole = cookies.get("USER_ROLE");

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const navToMetalsPage = () => {
    navigate("/metals");
  };

  const selectOffice = (office: string) => {
    cookies.set("CURR_OFFICE", office, {
      path: "/",
    });
    navToMetalsPage();
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={24}>
                <Row justify="start">
                  <h2 className="offices-title">Offices</h2>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row className="summary-container" justify="center" align="middle">
              <Button
                className={
                  userRole === "userbw"
                    ? "pg-office-disabled"
                    : currOffice === "pg"
                    ? "pg-office-card-selected"
                    : "pg-office-card"
                }
                onClick={() => selectOffice("pg")}
                disabled={userRole === "userbw"}
              >
                <Row justify="center" align="middle" style={{ height: "100%" }}>
                  <h1>Penang</h1>
                </Row>
              </Button>
              <Button
                className={
                  userRole === "userpg"
                    ? "bw-office-disabled"
                    : currOffice === "bw"
                    ? "bw-office-card-selected"
                    : "bw-office-card"
                }
                onClick={() => selectOffice("bw")}
                disabled={userRole === "userpg"}
              >
                <Row justify="center" align="middle" style={{ height: "100%" }}>
                  <h1>Butterworth</h1>
                </Row>
              </Button>
            </Row>
          </Col>
        </Row>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default HomePage;
